<template>
  <div class="table-box">
    <mf-loading :loader="['last-update', 'primeiro-registro', 'produtos-mais-cupons-top']" loader-type="table">
      <v-container fluid grid-list-md>
        <v-layout>
          <v-flex v-for="(card, index) in cards" :key="index" xs4>
            <cbm-card
              :number-text="card.value"
              :title="card.text"
              unset-percentage-colors
              simple-card
              :percent-text="card.underText"
              :loader="card.loader"
              :is-integer="card.isInteger"
            />
          </v-flex>
        </v-layout>
      </v-container>
      <v-data-table :headers="headers" :items="dadosTabela" hide-default-footer disable-pagination @current-items="updateSelectedItems">
        <template v-slot:item="{ item }">
          <tr>
            <td>{{ item.index }}</td>
            <td>
              <router-link class="link" :to="{ path: `/produtos/detalhes-produto/${item['COD_ID_PRODUTO']}` }">
                {{ item['COD_ID_PRODUTO'] }} - {{ item['DES_PRODUTO'] }}
              </router-link>
            </td>
            <td class="text-right">{{ item['NUM_CUPONS_TOTAL'] | localeString }}</td>
            <td class="text-right">{{ item['VAL_FATURAMENTO_TOTAL'] | localeString(2) | currency }}</td>
            <td class="text-right">{{ item['NUM_CLIENTES_TOTAL'] | localeString }}</td>
            <td class="text-right">{{ item['VAL_QUANTIDADE_KG_TOTAL'] | localeString(1) }}</td>
            <td class="text-right">{{ item['PORCENTAGEM'] | abreviation | percent }}</td>
          </tr>
        </template>
      </v-data-table>
    </mf-loading>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import { mapGetters } from 'vuex'
import { porcentagemProduto, localeString } from '@/config/helpers.js'
import CbmCard from '@/components/CbmCard.vue'
import { mapWaitingActions } from 'vue-wait'
import { productRanking } from '@/modules/produtos/ranking-produtos/mixins/productRanking'

export default {
  components: {
    CbmCard,
  },
  mixins: [productRanking],
  computed: {
    ...mapGetters(['produtosTopMaisCupons', 'produtosTotalCupons', 'produtosTotalTopCupons', 'produtosSkuAtivasVendas']),
    dadosTabela() {
      return cloneDeep(this.produtosTopMaisCupons).map((object, index) => {
        object['PORCENTAGEM'] = porcentagemProduto(object['NUM_CUPONS_TOTAL'], this.produtosTotalCupons)
        object.index = index + 1
        return object
      })
    },
    topCuponsPorcentagem() {
      return `${localeString((this.produtosTotalTopCupons / this.produtosTotalCupons) * 100, 1)} %`
    },
    cards() {
      return [
        {
          text: 'Total de cupons no período',
          value: this.produtosTotalCupons,
          underText: '100 %',
          loader: 'totais-cupons-produtos',
          isInteger: true,
        },
        {
          text: 'Cupons com os 100 produtos com mais presença em vendas',
          value: this.produtosTotalTopCupons,
          underText: this.topCuponsPorcentagem,
          loader: 'totais-cupons-produtos-top',
          isInteger: true,
        },
        {
          text: 'Produtos distintos vendidos no período',
          value: this.produtosSkuAtivasVendas,
          loader: 'totais-cupons-produtos',
          isInteger: true,
        },
      ]
    },
  },
  methods: {
    ...mapWaitingActions({
      totaisCuponsProdutos: 'totais-cupons-produtos',
      totaisCuponsProdutosTop: 'totais-cupons-produtos-top',
      produtosMaisCuponsTop: 'produtos-mais-cupons-top',
    }),
    internalGetData(filter) {
      return [this.totaisCuponsProdutos(filter), this.totaisCuponsProdutosTop(filter), this.produtosMaisCuponsTop(filter)]
    },
  },
}
</script>
